import { EMPTY_ARRAY } from 'utility/fieldHelpers';

export const CALENDAR_EVENTS_OPTIONS = {
  upcoming: 'upcoming',
  past: 'past',
};

export const EVENT_ACTIONS = {
  stats: 'stats',
  edit: 'edit',
  duplicate: 'duplicate',
  delete: 'delete',
};

export const EVENT_STATUSES = {
  failed: 'failed',
  completed: 'completed',
  scheduled: 'scheduled',
  prestarted: 'prestarted',
};

export const EVENT_TYPES = {
  email: {
    type: 'email',
    getTitle: (t, event) =>
      (event?.status === EVENT_STATUSES.failed ? `(${t('Failed')}) ` : '') +
      (event?.name || t('Email')),
    getContent: (t, action) => action?.subject || t('Subject'),
    getTooltip: (t) => `${t('Show/Hide')} ${'Emails'}`,
    icon: 'envelope',
    color: 'var(--color-viz-cat-2-primary)',
    accessKey: 'scheduled_emails',
  },
  text: {
    type: 'text',
    getTitle: (t, event) => event?.name || t('Text'),
    getContent: (t, action) => action?.subject || t('Subject'),
    getTooltip: (t) => `${t('Show/Hide')} ${t('Texts')}`,
    icon: 'mobile',
    color: 'var(--color-viz-cat-2-primary)',
    preRelease: true,
  },
  automation: {
    type: 'automation',
    getTitle: (t, event) =>
      (event?.status === EVENT_STATUSES.failed ? `(${t('Failed')}) ` : '') +
      (event?.name || t('Agentic Workflow')),
    getContent: (t, action) =>
      action?.automations
        .map(
          ({ name, deleted, active }) =>
            `${
              deleted
                ? `[${t('DELETED')}] `
                : active === false
                  ? `[${t('INACTIVE')}] `
                  : ''
            }${name}`
        )
        .join(', '),
    getTooltip: (t) => `${t('Show/Hide')} ${t('Agentic Workflows')}`,
    icon: 'sync-light',
    color: 'var(--color-viz-cat-4-primary)',
    accessKey: 'scheduled_automations',
  },
  facebook: {
    type: 'facebook',
    getTitle: (t, event) => event?.name || t('Facebook Post'),
    getContent: (t, action) => action?.subject || t('Subject'),
    getTooltip: (t) => `${t('Show/Hide')} ${t('Facebook Posts')}`,
    icon: 'facebook',
    color: 'var(--color-viz-cat-5-primary)',
    preRelease: true,
  },
  twitter: {
    type: 'twitter',
    getTitle: (t, event) => event?.name || t('Twitter Post'),
    getContent: (t, action) => action?.subject || t('Subject'),
    getTooltip: (t) => `${t('Show/Hide')} ${t('Twitter Posts')}`,
    icon: 'twitter',
    color: 'var(--color-viz-cat-5-primary)',
    preRelease: true,
  },
  activity: {
    type: 'activity',
    getTitle: (t, event) => event?.name || t('Activity'),
    getContent: (t, action) => action?.subject || t('Subject'),
    getTooltip: (t) => `${t('Show/Hide')} ${t('Activities')}`,
    icon: 'clipboard',
    color: 'var(--color-viz-cat-2-primary)',
  },
  default: {
    type: 'default',
    getTitle: (t) => t('Unknown Event'),
    getContent: (t, action) => action?.subject || t('Subject'),
    getTooltip: (t) => t('Show/Hide'),
    icon: 'bars-light',
    color: 'var(--color-background-dark)',
  },
};

export const SUMMARY_ACTIONS = {
  [EVENT_TYPES.email.type]: 'bulk_send_email',
  [EVENT_TYPES.automation.type]: 'start_automation',
};

export const EVENTS_PER_PAGE = 20;

export const EVENTS_SEARCH_DATA = {
  previous: null,
  next: null,
  results: EMPTY_ARRAY,
  count: 0,
  errors: null,
};
